export default "__VITE_ASSET__BNs5pW9$__"